import { reasonToDescription } from "@atoms/atom-types";
import type { NoAccessScreenProps } from "../FrontendProvision";

export function DefaultNoAccessScreen({
  reason,
  detail,
  statusCode,
  onRetry,
  onSignOut,
}: Readonly<NoAccessScreenProps>) {
  const message = reasonToDescription[reason] ?? reasonToDescription.unknown;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        boxSizing: "border-box",
      }}
    >
      <div style={{ maxWidth: "560px", textAlign: "center" }}>
        <h1 style={{ marginBottom: "12px" }}>Access denied</h1>
        <p style={{ marginBottom: "8px" }}>{message}</p>
        {statusCode ? (
          <p style={{ marginTop: 0, opacity: 0.75 }}>
            Status code: {statusCode}
          </p>
        ) : null}
        {detail ? (
          <p
            style={{ marginTop: "16px", opacity: 0.8, wordBreak: "break-word" }}
          >
            {detail}
          </p>
        ) : null}
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            onClick={onRetry ?? (() => globalThis.location.reload())}
          >
            Retry
          </button>
          {onSignOut ? (
            <button type="button" onClick={onSignOut}>
              Sign out
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
